import { render, staticRenderFns } from "./CoachCard.vue?vue&type=template&id=484907ac"
import script from "./CoachCard.vue?vue&type=script&lang=js"
export * from "./CoachCard.vue?vue&type=script&lang=js"
import style0 from "./CoachCard.vue?vue&type=style&index=0&id=484907ac&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports